module.exports = __webpack_public_path__ + "img/Business-text.6adefb9c.jpg";